import { render } from "./page-holder.vue?vue&type=template&id=189d36bc"
import script from "./page-holder.vue?vue&type=script&lang=js"
export * from "./page-holder.vue?vue&type=script&lang=js"

import "./page-holder.vue?vue&type=style&index=0&id=189d36bc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__